export default {
  init() {
    // JavaScript to be fired on all pages
    $('.mobile-menu .heading').addClass('closed');

    $('.mobile-burger').on('click touch', function() {
      $(this).toggleClass('opened');
      $('.mobile-menu').toggleClass('opened');
    });

    $('.mobile-menu .heading').on('click touch', function() {
      $(this).toggleClass('closed');
    });
    
    $('.faq-heading').on('click touch', function() {
      var width = $(window).innerWidth();
      var id = '';
        //close other ones
        $('.faq-content.open, .faq-content-mobile.open').animate({
          height: 0,
        }, 300);
        $('.faq-content.open').removeClass('open');
        $(this).siblings().removeClass('open'); //the mobile cntents are siblings to $(this)
        //open the new one - desktop
        if (width > 991) {
          id = '#' + $(this).data('id');
        } else {
          id = '#mobile-' + $(this).data('id');
        }
        var $faq = $(id);
        $faq.animate({
          height: $faq[0].scrollHeight,
        });
        $faq.addClass('open');
        $(this).addClass('open');
    });

    $(window).ready(function() {
      $('.faq-heading').first().click();
    });

    const positionCarouselControls = () => {
      const isTabletOrBelow = window.matchMedia('(max-width: 1024px)').matches;
      const $blocks = $('.carousel-block');

      $blocks.each(function() {
        const $block = $(this);
        const $container = $block.find('.container-xl').first();
        const $indicators = $block.find('.carousel-indicators').first();
        const $prev = $block.find('.carousel-control-prev').first();
        const $next = $block.find('.carousel-control-next').first();

        if (!$container.length || !$indicators.length || !$prev.length || !$next.length) {
          return;
        }

        if (!isTabletOrBelow) {
          $prev.removeAttr('style');
          $next.removeAttr('style');
          return;
        }

        const containerRect = $container[0].getBoundingClientRect();
        const indicatorsRect = $indicators[0].getBoundingClientRect();
        const prevRect = $prev[0].getBoundingClientRect();
        const nextRect = $next[0].getBoundingClientRect();
        const gap = 12;
        const centerY = indicatorsRect.top + (indicatorsRect.height / 2) - containerRect.top;
        const prevLeft = indicatorsRect.left - containerRect.left - prevRect.width - gap;
        const nextLeft = indicatorsRect.right - containerRect.left + gap;

        $prev.css({
          top: `${centerY - (prevRect.height / 2)}px`,
          left: `${Math.max(prevLeft, 0)}px`,
          bottom: 'auto',
          right: 'auto',
        });

        $next.css({
          top: `${centerY - (nextRect.height / 2)}px`,
          left: `${Math.max(nextLeft, 0)}px`,
          bottom: 'auto',
          right: 'auto',
        });
      });
    };

    let carouselPositionTimeout;
    const queueCarouselPosition = () => {
      clearTimeout(carouselPositionTimeout);
      carouselPositionTimeout = setTimeout(positionCarouselControls, 50);
    };

    $(window).on('load resize orientationchange', queueCarouselPosition);
    $('.carousel').on('slid.bs.carousel', queueCarouselPosition);
    queueCarouselPosition();
    // var current_horizontal_scroll_position = 0;
    // var last_scroll_top = window.scrollY;
    // var scroll_speed = 20;

    // $(window).scroll(function() {
    //   var scroll_offset = $('.scroller').offset().top;
    //   var half_screen = $(window).height() / 2; //half of the screen
    //   var current_vertical_scroll_position = window.scrollY;
    //   var scroller_length = $('.scroller').width();
    //   var start_scrolling = scroll_offset - half_screen;

    //   if (current_vertical_scroll_position >= start_scrolling && current_horizontal_scroll_position < scroller_length) {
    //     if (last_scroll_top > current_vertical_scroll_position) { //going up
    //       current_horizontal_scroll_position += scroll_speed;
    //     } else {
    //       current_horizontal_scroll_position -= scroll_speed;
    //     }
    //     $('.scroller').css('transform', 'translate(' + current_horizontal_scroll_position + 'px, 0px)');
    //     last_scroll_top = window.scrollY;
    //   }
      
      
    // });
   

    

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js